export default {
    base: {
        inter: '国际化',
        developing: '开发中...',
    },
    home: {
        msg: '幸运抽奖',
        wisdom: '幸运是机会的影子。—— 苏格拉底',
        downTem: '下载数据模板',
        lc: '幸运卡片',
        lw: '幸运转盘',
        lcl: '幸运点云',
        ls: '幸运之星',
        am: '关于我',
        co: '联系',
        sup: '支持',
        dev: '开发者',
        sin: '微博：',
        eml: '邮箱：',
        pay: '打赏码',
        wechatPayTip: '请在微信中长按此二维码'
    },
    list: {
        cell: {},
        clTitle: '你确定要清空数据吗？',
        clCache: '你确定要清空缓存吗？',
        content: '这个操作将不可恢复！',
        okText: '确定',
        cancelText: '取消',
        ad: '添加',
        cl: '清空',
        del: '删除',
        dela: '确定删除？',
        col: '[{"title":"序号","dataIndex":"key"},{"title":"标题","dataIndex":"name","width":"20%"},{"title":"副标题","dataIndex":"subtitle","width":"20%"},{"title":"图片链接","dataIndex":"url","width":"30%"},{"title":"备注","dataIndex":"remark"},{"title":"操作","dataIndex":"operation","width":"100px","fixed":"right"}]'
    },
    luckCard: {
        header: {
            title: "幸运卡片",
            subtitle: "^^",
            rr: "随机刷新",
            cc: "清空缓存",
            st: "设置",
        },
        card: {
            remark: '请输入获奖者',
            winner: '已备注',
            clear: '已清除'
        },
        no: '编号：',
        listTitle: '卡片数据源：'
    },
    luckWheel: {
        header: {
            title: "幸运转盘",
            subtitle: "^^",
            rr: "随机刷新",
            cc: "清空缓存",
            st: "设置",
        },
        listTitle: '转盘数据源：'
    },
    luckCloud: {
        header: {
            title: "幸运点云",
            subtitle: "^^",
            rr: "随机刷新",
            cc: "清空缓存",
            st: "设置",
        },
        listTitle: '点云数据源：',
        selectedTitle: '选中名单',
        selectedSubtitle: 'Ψ=Ψ（x，y，z，t）',
        placeholder: '筛选数量',
        switchTips: '是否允许重复选中',
        allow: '允许',
        ban: '禁止',
        go: '自动',
        start: '开始',
        stop: '停止'
    },
    luckStar: {
        header: {
            title: "幸运之星",
            subtitle: "^^",
            rr: "随机刷新",
            cc: "清空缓存",
            st: "设置",
        },
        go: '自动',
        start: '开始',
        stop: '停止',
        noMore0: '没有选项了!',
        noMore1: '仅剩一个选项!',
        message: '提示',
        description: '选项不足，请点击\'设置\'添加选项',
        emptyTip: '请点击\'抽奖\'按钮',
        listTitle: '幸运星数据源：'
    }
};
